import Accordions from './modules/accordion';
import Modals from './modules/modal';
import Zaiko from './modules/zaiko';
import '../scss/index.scss';

document.addEventListener('DOMContentLoaded',function(){


  //在庫制御
  const carts = document.querySelectorAll('.js-zaiko');
  const zaikoFlag = 'zaiko-completed';
  const zaikocb = function (entries, observer) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        if(!entry.target.classList.contains(zaikoFlag)){
          new Zaiko(entry.target);
          entry.target.classList.add(zaikoFlag);
        }
        observer.unobserve(entry.target);
      }
    });
  };
  const zaikoIOoptions = {
      root: null,
      rootMargin: "100px",
      threshold: 0
  };
  const zaikoio = new IntersectionObserver(zaikocb, zaikoIOoptions);
  if(carts){
    carts.forEach(cart => zaikoio.observe(cart));
  }

  //Accordion
  const accBtns = Array.from(document.querySelectorAll('.js-acc-btn'));
  accBtns.forEach((accordionBtn) => {
    new Accordions(accordionBtn);
  });

  //Modal window
  const modalBtns = Array.from(document.querySelectorAll('.js-modal-open'));
  modalBtns.forEach((modalBtn) => {
    new Modals(modalBtn);
  });

});

function onClick(){
  var clickObj = $(".scClick");
  clickObj.each (function(){
    var clickID = $(this).attr("data-clickid");
    var clickLink = $(this).attr("href");
    $(this).attr("onclick","_sc.gene_click('" + clickID + "','" + clickLink +"');");
  })
}
onClick();

var fixedContent = $(".fixed");
var defTop = fixedContent.offset().top;
var fixclass = "m-fixed";
var fixedDisappear = $('.sec_attention');
$(window).on("scroll", function () {
  var scrT = $(window).scrollTop();
  var offTop = fixedDisappear.offset().top;
  if (scrT >= defTop && scrT <= offTop) {
    $(".mod-fixednav.m-upper").addClass(fixclass);
  } else{
    $(".mod-fixednav.m-upper").removeClass(fixclass);
  }
});

var fixedContentBottom = $(".fixedbottom");
var defTop2 = fixedContentBottom.offset().top;
var fixclass = "m-fixed";
var fixedDisappear = $('.sec_attention');
$(window).on("scroll", function () {
  var scrT = $(window).scrollTop();
  var offTop = fixedDisappear.offset().top;
  // if (scrT >= defTop && scrT <= offTop) {
  if (scrT >= defTop2) {
      $(".mod-fixednav.m-bottom").addClass(fixclass);
  } else{
    $(".mod-fixednav.m-bottom").removeClass(fixclass);
  }

});


